import { Link } from '@remix-run/react'
import { Icon } from '../icons/Icon'

type logoProps = {
  variant?: 'dark' | 'light'
  onClose?: () => void
  className?: string
  iconClassName?: string
}

export default function Logo({
  variant = 'dark',
  onClose,
  className,
  iconClassName,
}: logoProps) {
  return (
    <Link to={'/'} onClick={onClose} className={className}>
      <Icon
        name={variant === 'light' ? 'basic/logo-white' : 'basic/logo-black'}
        size="28px"
        className={iconClassName ?? 'h-[28px] w-[220px]'}
      />
    </Link>
  )
}
